const lbToggle = angular.module('app.lbToggle', []);

lbToggle.controller('lbToggleCtrl', require('./lbToggleCtrl'));
lbToggle.component('lbToggle', require('./lbToggle'));

export default lbToggle;



// WEBPACK FOOTER //
// ./src/components/lbToggle/index.js